import Swal from 'sweetalert2'

export const ToastFire = (icon = null, title = null, timer = null) => {
  const ToastAlert = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: timer || 6000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  })
  return ToastAlert.fire({
    icon: icon || 'warning',
    title: title || '',
  })
}

export const SwalFire = async (title = null, text = null, icon = null, txtBtn = null, showCancel = null) => {
  let res
  await Swal.fire({
    title: title || '',
    text: text || '',
    icon: icon || 'warning',
    showCancelButton: showCancel !== false || false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: txtBtn || 'Si, eliminar',
    cancelButtonText: 'No',
  }).then(async (result) => {
    if (result.isConfirmed) {
      res = true
    } else {
      res = false
    }
  })
  return res
}
export const showErrorFile = (error) => {
  const ToastAlert = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 6000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    },
  })
  error.response.data.text().then(text => {
    return ToastAlert.fire({
      icon: 'warning',
      title: JSON.parse(text).msg || 'Ha ocurrido un error.',
    })
  })
}
